(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-measurement-controls]').forEach((controls) => { controls.hidden = false; });
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-measurement-unit]');
    if (!button) return;
    const container = button.closest('[data-measurements]');
    const inches = button.dataset.measurementUnit === 'in';
    container.querySelectorAll('[data-measurement-cm]').forEach((cell) => {
      const value = cell.dataset.measurementCm;
      const measurement = value.trim().match(/^(\d+(?:[.,]\d+)?)(?:([ \t]*[–—-][ \t]*)(\d+(?:[.,]\d+)?))?$/);
      const convert = number => (Number(number.replace(',', '.')) / 2.54).toLocaleString(document.documentElement.lang, { maximumFractionDigits: 1 });
      cell.textContent = inches && measurement
        ? convert(measurement[1]) + (measurement[3] ? measurement[2] + convert(measurement[3]) : '')
        : value;
    });
    container.querySelector('caption').textContent = container.querySelector(inches ? '[data-caption-in]' : '[data-caption-cm]').textContent;
    container.querySelectorAll('[data-measurement-unit]').forEach((control) => control.setAttribute('aria-pressed', String(control === button)));
  });
  initialize();
  // Product sections are replaced on variant selection and when quick view opens.
  new MutationObserver((records) => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node.nodeType === Node.ELEMENT_NODE) initialize(node);
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
